// extracted by mini-css-extract-plugin
export default {"version":"Layout_version__jSuAl","main":"Layout_main__FV28D"};